import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";

export default function AdminLoginPage() {
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const r = await api.post("/admin/login", { password: pw });
      localStorage.setItem("aabb_admin_token", r.data.access_token);
      nav("/admin");
    } catch (ex) {
      setErr(ex?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div style={{minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center",
                 background:"var(--black)", padding:"24px"}}>
      <form onSubmit={submit} data-testid="admin-login-form" style={{
        background:"var(--dark)", border:"1px solid rgba(193,127,58,.25)", borderRadius:14,
        padding:"36px 32px", width:"100%", maxWidth:420
      }}>
        <div className="aa-eyebrow">Internal</div>
        <h1 className="aa-h1" style={{marginBottom:8}}>Admin sign in</h1>
        <p className="aa-sub" style={{marginBottom:24}}>Restricted access. Authorized personnel only.</p>
        <label className="aa-label">Password</label>
        <input className="aa-input" type="password" value={pw} onChange={(e)=>setPw(e.target.value)}
               autoFocus data-testid="admin-pw-input" />
        {err && <div className="aa-error" data-testid="admin-login-error">{err}</div>}
        <button className="aa-btn" style={{marginTop:18, width:"100%"}} disabled={busy || !pw}
                data-testid="admin-login-submit">{busy ? "Signing in…" : "Sign in"}</button>
      </form>
    </div>
  );
}
